import './src/scss/theme.scss'
import('../../src/js/app')

$(document).ready(function () {
    function syncTopbarCtaOffset() {
        const topBar = document.querySelector('.top-bar')
        const hasTopBar = Boolean(topBar)
        document.body.classList.toggle('has-topbar-cta', hasTopBar)
    
        if (!hasTopBar) {
            document.body.style.removeProperty('--topbar-cta-height')
            return
        }
    
        const topBarHeight = Math.ceil(topBar.getBoundingClientRect().height)
        document.body.style.setProperty('--topbar-cta-height', `${topBarHeight}px`)
    }
    
    syncTopbarCtaOffset()
    window.addEventListener('load', syncTopbarCtaOffset)
    window.addEventListener('resize', syncTopbarCtaOffset)
    
    const topBar = document.querySelector('.top-bar')
    if (topBar) {
        const topBarResizeObserver = new ResizeObserver(syncTopbarCtaOffset)
        topBarResizeObserver.observe(topBar)
    }
})
